import { convertSfxData } from '@/api/sfx/convert-sfx-data';
import { v1Api } from '@/api/backendApi';

import type { BrowseType } from '@/types/browse';
import type { TracksPage } from '@/types/tracks';

interface Excluded {
  group: string;
  id: string;
}

export interface TrackOption {
  duration: string | null;
  excluded?: Excluded[];
  freeOnly?: number;
  id?: string | number;
  intensity?: string;
  isPremium?: boolean;
  limit?: number;
  merge?: boolean;
  page?: number;
  proximity?: string;
  quantity?: string;
  sort?: string;
  styleFilters?: string[];
  type?: BrowseType;
}

export const defaultTrackOptions: TrackOption = {
  type: '',
  id: 1,
  proximity: '0',
  quantity: '0',
  intensity: '0',
  sort: 'Relevance',
  duration: '0',
  styleFilters: [],
  page: 1,
  excluded: [],
  limit: -1,
  merge: false,
  freeOnly: 0,
  isPremium: false,
};

export const getAllSfxTracks = async (
  options: Partial<TrackOption>
): Promise<TracksPage> => {
  options = { ...defaultTrackOptions, ...options };

  let jsonStyleFilters;

  if (options.styleFilters != null) {
    jsonStyleFilters = JSON.stringify(options.styleFilters);
  }

  // Assign set system to array which can be used in URL.
  let jsonExcluded: number[][] | string = [];

  if (options.excluded != null) {
    for (let i = 0; i < options.excluded.length; i += 1) {
      jsonExcluded[i] = [];
      jsonExcluded[i][0] = Number.parseInt(options.excluded[i].id, 10);
      jsonExcluded[i][1] = Number.parseInt(options.excluded[i].group, 10);
    }

    jsonExcluded = JSON.stringify(jsonExcluded);
  }

  let endpoint = `sfxes/${options.type}/types/${options.id}/ids/${
    options.proximity
  }/proximities/${options.quantity}/quantities/${options.intensity}/intensities/${options.sort}/sorts/${
    options.duration ?? 0
  }/durations/${jsonStyleFilters}/stylefilters/${
    options.limit
  }/limits/${jsonExcluded}/excludes/${options.isPremium ? '1' : '0'}/premium/${
    options.freeOnly
  }/freeonly/${options.page}`;

  // Cache busting for taxonomy.
  if (options.type === 'collection') {
    endpoint += '?version=2';
  }

  const tracks = await v1Api.get<TracksPage>(endpoint).then((r) => r.data);

  return convertSfxData(tracks) as TracksPage;
};
